__turbopack_context__.v({
  "cButton": "style-module-scss-module__Lc1U7W__cButton",
  "cButtonFilters": "style-module-scss-module__Lc1U7W__cButtonFilters",
  "cButtonFilters____noWidth": "style-module-scss-module__Lc1U7W__cButtonFilters____noWidth",
  "cButton____isActive": "style-module-scss-module__Lc1U7W__cButton____isActive",
  "cItem": "style-module-scss-module__Lc1U7W__cItem",
  "cItem__bottomWrap": "style-module-scss-module__Lc1U7W__cItem__bottomWrap",
  "cItem__optionsWrap": "style-module-scss-module__Lc1U7W__cItem__optionsWrap",
  "cItem__slotsWrap": "style-module-scss-module__Lc1U7W__cItem__slotsWrap",
  "cItem__tabNavWrap": "style-module-scss-module__Lc1U7W__cItem__tabNavWrap",
  "cItem__title": "style-module-scss-module__Lc1U7W__cItem__title",
  "cSort": "style-module-scss-module__Lc1U7W__cSort",
  "cSort__btnWrap": "style-module-scss-module__Lc1U7W__cSort__btnWrap",
  "cSort__vLine": "style-module-scss-module__Lc1U7W__cSort__vLine",
});
